import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'
const equipRouter = {
  path: '/expertManage',
  redirect: 'expertManage',
  name: 'expertManage',
  component: Layout,
  children: [
    {
      path: 'expertManage',
      component: () => import('@/views/expertManage/index.vue'),
      name: 'expertManage',
      meta: {
        title: '课题申报管理',
        icon: 'tissue',
        requireAuth: true,
      }
    }
  ]
}

export default equipRouter
